import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
    // Initialize Google Analytics here if needed
    // gtag('consent', 'update', { analytics_storage: 'granted' });
  };

  const rejectCookies = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm">
            We use cookies to improve your experience and for analytics.
            <a href="/privacy" className="underline ml-1">Learn more</a>
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={rejectCookies}
            className="px-4 py-2 text-sm border border-gray-500 rounded hover:bg-gray-800 transition-colors"
          >
            Reject
          </button>
          <button
            onClick={acceptCookies}
            className="px-4 py-2 text-sm text-white rounded transition-colors"
            style={{ backgroundColor: '#615DEC' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#4c47c7';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#615DEC';
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;